// extracted by mini-css-extract-plugin
module.exports = {"title":"_unauthorized_title_2kv0d"};